import(/* webpackMode: "eager" */ "/vercel/path0/src/app/u/[handle]/error.tsx");
